export const DEFAULT_TILE_DIMENSIONS = {
  WIDTH: 141,
  HEIGHT: 250,
};
